import { TransactionType } from '../../../providers/TransactionsProvider';
import { useDateRangeDisplayText, type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';
import {
  AverageTransactionsRow,
  LargestTransactionRow,
  PreviousTotalRow,
  TotalRow,
  TotalTransactionsRow,
} from '../rows';

import type { ColumnTable } from 'arquero';

export interface ITransactionSummaryProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
  type?: TransactionType;
  className?: string;
}

const TransactionSummary = ({
  transactions,
  dateRange,
  type = TransactionType.Spending,
  className,
}: ITransactionSummaryProps) => {
  const dateRangeDisplayText = useDateRangeDisplayText(dateRange);

  const isIncome = type === TransactionType.Income;

  return (
    <Widget className={className}>
      <Widget.Header
        title="Summary"
        trailing={<span className="text-tertiary text-xs font-medium">{dateRangeDisplayText}</span>}
      />

      <Widget.Body className="pb-2 pt-1">
        <TotalTransactionsRow transactions={transactions} dateRange={dateRange} />
        <AverageTransactionsRow
          transactions={transactions}
          dateRange={dateRange}
          showSign={isIncome}
          colored={isIncome}
          negateAmount={isIncome}
        />
        <div className="border-tertiary border-b">
          <LargestTransactionRow
            transactions={transactions}
            dateRange={dateRange}
            showSign={isIncome}
            colored={isIncome}
            negateAmount={isIncome}
          />
        </div>
        <TotalRow
          transactions={transactions}
          dateRange={dateRange}
          showSign={isIncome}
          colored={isIncome}
          negateAmount={isIncome}
        />
        <PreviousTotalRow
          transactions={transactions}
          dateRange={dateRange}
          showSign={isIncome}
          colored={isIncome}
          negateAmount={isIncome}
        />
      </Widget.Body>
    </Widget>
  );
};

export default TransactionSummary;
